<div class="left-content" *ngIf="bookDetail">
	<svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
		<symbol id="bi-volume-down-fill" viewBox="0 0 16 16">
			<path
				d="M9 4a.5.5 0 0 0-.812-.39L5.825 5.5H3.5A.5.5 0 0 0 3 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 9 12V4zm3.025 4a4.486 4.486 0 0 1-1.318 3.182L10 10.475A3.489 3.489 0 0 0 11.025 8 3.49 3.49 0 0 0 10 5.525l.707-.707A4.486 4.486 0 0 1 12.025 8z" />
		</symbol>
		<symbol id="bi-search" viewBox="0 0 16 16">
			<path
				d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
		</symbol>
		<symbol id="bi-mic-fill" viewBox="0 0 16 16">
			<path d="M5 3a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0V3z" />
			<path
				d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5z" />
		</symbol>
		<symbol id="bi-google" viewBox="0 0 256 262" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
			<path
				d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
				fill="#4285F4" />
			<path
				d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
				fill="#34A853" />
			<path
				d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
				fill="#FBBC05" />
			<path
				d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
				fill="#EB4335" />
		</symbol>
	</svg>

	<!-- <svg class="" width="16" height="16"><use xlink:href="#volume-down-fill"/></svg> -->

	<div class="head-deatail">
		<a (click)="onClickGoogleImage(bookDetail?.id)" id="googleIcon">
			<svg class="bi-button-round p-2">
				<use xlink:href="#bi-google" />
			</svg>
		</a>
		<div class="title-name">
			<a *ngFor="let w of setupMenuDictionaryItems(bookDetail?.id)" class="pl-1" data-toggle="popover"
				title="Dictionary Online" data-content="">
				{{w + ' '}}
			</a>
		</div>
		<div (click)="onClickVolumeIcon(bookDetail?.id)" class="auto-play-audio">
			<svg class="bi-button-round">
				<use xlink:href="#bi-volume-down-fill" />
			</svg>
		</div>
	</div>

	<div class="row row-cols-1 row-cols-md-2">
		<div class="col card border-0 px-4 px-md-2">
			<div class="title-key1">
				<div class="head-key">
					<div class="name-key">
						<div class="key1">
							<a *ngFor="let w of setupMenuDictionaryItems(bookDetail?.keyword1?.keyword_en)" class="pl-1"
								data-toggle="popover" title="Dictionary Online" data-content="">
								{{w + ' '}}
							</a>
						</div>
					</div>
					<div class="icon-head-key" (click)="onClickVolumeIcon(bookDetail?.keyword1?.keyword_en)">
						<svg class="bi-button-round">
							<use xlink:href="#bi-volume-down-fill" />
						</svg>
					</div>
				</div>
				<div class="spelling_en">{{ bookDetail?.keyword1?.spelling_en }}</div>
				<div class="trans-key-en">
					<div class="bodyKeyword">
						<img class="imgKeyword" [src]="getCdnImage(bookDetail?.keyword1?.urlKeyword1)" />
						<span>{{ bookDetail?.keyword1?.keyword_vn }}</span>
					</div>
					<!-- <div class="par-mic-icon" (click)="onClickMicIcon(bookDetail?.keyword1)">
                <svg class="bi-button-round"><use xlink:href="#bi-mic-fill"/></svg>
            </div> -->
				</div>
				<div class="keyword1">
					<svg class="bi-button-round border-0" (click)="onClickGoogleImage(bookDetail?.keyword1?.howto_en)">
						<use xlink:href="#bi-google" />
					</svg>
					<span class="howto_en">
						<a *ngFor="let w of setupMenuDictionaryItems(bookDetail?.keyword1?.howto_en)" class="pl-1"
							data-toggle="popover" title="Dictionary Online" data-content="">
							{{w + ' '}}
						</a>
					</span>
					<div class="icon-head-key icon-volume-how"
						(click)="onClickVolumeIcon(bookDetail?.keyword1?.howto_en)">
						<svg class="bi-button-round">
							<use xlink:href="#bi-volume-down-fill" />
						</svg>
					</div>
				</div>
			</div>
		</div>
		<div class="col card border-0 px-4 px-md-2">
			<div class="title-key1">
				<div class="head-key">
					<div class="name-key">
						<div class="key1">						
							<a *ngFor="let w of setupMenuDictionaryItems(bookDetail?.keyword2?.keyword_en)" class="pl-1"
								data-toggle="popover" title="Dictionary Online" data-content="">
								{{w + ' '}}
							</a>
						</div>
					</div>
					<div class="icon-head-key" (click)="onClickVolumeIcon(bookDetail?.keyword2?.keyword_en)">
						<i class="bi bi-arrow-down-right-square"></i>
						<svg class="bi-button-round">
							<use xlink:href="#bi-volume-down-fill" />
						</svg>
					</div>
				</div>
				<div class="spelling_en">{{ bookDetail?.keyword2?.spelling_en }}</div>
				<div class="trans-key-en">
					<div class="bodyKeyword">
						<img class="imgKeyword" [src]="getCdnImage(bookDetail?.keyword2?.urlKeyword2)" />
						<span>{{ bookDetail?.keyword2?.keyword_vn }}</span>
					</div>
					<!-- <div class="par-mic-icon" (click)="onClickMicIcon(bookDetail?.keyword2)">
                <svg class="bi-button-round"><use xlink:href="#bi-mic-fill"/></svg>
            </div> -->
				</div>
				<div class="keyword2">
					<svg class="bi-button-round p-2 border-0"
						(click)="onClickGoogleImage(bookDetail?.keyword2?.howto_en)">
						<use xlink:href="#bi-google" />
					</svg>
					<span class="howto_en">
						<a *ngFor="let w of setupMenuDictionaryItems(bookDetail?.keyword2?.howto_en)" class="pl-1"
							data-toggle="popover" title="Dictionary Online" data-content="">
							{{w + ' '}}
						</a>
					</span>
					<div class="icon-head-key icon-volume-how"
						(click)="onClickVolumeIcon(bookDetail?.keyword2?.howto_en)">
						<svg class="bi-button-round">
							<use xlink:href="#bi-volume-down-fill" />
						</svg>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
